/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_copy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const es_wsc_copy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const de_wsc_copy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren`)
};

const nl_wsc_copy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiëren`)
};

const fr_wsc_copy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier`)
};

const it_wsc_copy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia`)
};

const pt_br2_wsc_copy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const pt_wsc_copy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const ja_wsc_copy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピー`)
};

const zh_wsc_copy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_copy = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_copy(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_copy", locale)
	if (locale === "en") return en_wsc_copy(inputs)
	if (locale === "es") return es_wsc_copy(inputs)
	if (locale === "de") return de_wsc_copy(inputs)
	if (locale === "nl") return nl_wsc_copy(inputs)
	if (locale === "fr") return fr_wsc_copy(inputs)
	if (locale === "it") return it_wsc_copy(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_copy(inputs)
	if (locale === "pt") return pt_wsc_copy(inputs)
	if (locale === "ja") return ja_wsc_copy(inputs)
	return zh_wsc_copy(inputs)
};